import { Authorized } from '@evolve/common-ui'
import React from 'react'

// ! Export default is not supported. It must be like this, otherwise it won't work!!
export function wrapPagesDeep({ element }: any) {
	return <Authorized>{element}</Authorized>
}

// ! Since export default doesn't work due to a bug in Gatsby, and we need it, we fake an export default empty
export default {}
